import { FC } from "react";
import { ReactAdminProvider } from "./react-admin.provider";

const Providers: FC = () => {
  return <ReactAdminProvider />;
};

export { Providers };
